// extracted by mini-css-extract-plugin
module.exports = {"form__control":"input_form__control__L1al_","input":"input_input__oerZQ"};